import { type SlackUserConstructor } from '@webapp/platform/integrations/entities/SlackUser/SlackUser'
import { type SlackUserApiModel } from '../api-models/SlackUserApiModel'

export const mapSlackUserApiModel = (
  apiModel: SlackUserApiModel
): SlackUserConstructor => ({
  id: apiModel.id,
  name: apiModel.name,
  realName: apiModel.real_name ?? null,
  email: apiModel.profile?.email ?? null,
})
